import { render, staticRenderFns } from "./EditInquiry.vue?vue&type=template&id=93048b00&"
import script from "./EditInquiry.vue?vue&type=script&lang=js&"
export * from "./EditInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports